import SoundClass from '../../../../classes/sound_class'

export default class Metronom {
  constructor(bpm, has_metronom = true, has_accent = false, vue = false) {
    console.log('METRONOM CONSTRUCTOR');
    this.sound = new SoundClass(this, 'main_library');
    this.has_accent = has_accent;
    this.has_metronom = has_metronom;
    this.bpm = bpm;
    this.metronom_timer = '';
    this.vue = vue;

    if (this.vue) {
      this.vue.$on('start app', this.play.bind(this));
      this.vue.$on('finish app', this.stop.bind(this));
      this.vue.$on('change speed', this.restart.bind(this));
      this.vue.$on('destroy app', this.destroy.bind(this));
    }
  }

  async restart(){
    console.log('CHANGE SPEED');
    await this.stop();
    this.play();
  }

  async destroy() {
    console.log('DESTROY METRONOM');
    await this.stop();
    this.metronom_timer = '';
    this.vue.$off('start app');
    this.vue.$off('finish app');
    this.vue.$off('destroy app');
    this.vue.$off('change speed');
  }

  timerSpeed() {
    return 60 / this.bpm * 1000;
  }

  startMetronomTimer(cb) {
    let app = this;
    let i = 0;
    this.metronom_timer = setInterval(() => {
      if (this.has_metronom) {
        cb.call(app, i);
      }
      i++;
    }, this.timerSpeed());
  }

  test() {
    console.log(this);
    this.playSound(2);
  }

  playSound(i) {
    let sound1 = 'click3';
    //let sound2 = 'click3';
    let sound2 = this.has_accent ? 'click1' : sound1;
    this.sound.play((i % 4 === 0) ? sound2 : sound1);
  }

  play() {
    this.startMetronomTimer(this.playSound);
  }

  stop() {
    return clearInterval(this.metronom_timer);
  }

}